module.exports = __webpack_public_path__ + "static/img/06.75af3c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/06.jpg
// module id = wP6j
// module chunks = 0